import { useEffect } from 'react';
import { EmojiDizzy } from 'react-bootstrap-icons';
import { Navigate, useParams } from 'react-router-dom';

import { Button, Spin, Typography } from 'antd';

import EmptyState from '@/components/shared/EmptyState';
import { useAppSelector } from '@/hooks/redux';
import IUser from '@/interfaces/user';
import { useAcceptInviteMutation } from '@/services/invites';
import { logout } from '@/services/token';
import styled from '@/styled';

const Invite = () => {
  const { inviteId } = useParams();

  const [acceptedInvite, { error, isLoading, isUninitialized }] = useAcceptInviteMutation();
  const user = useAppSelector(state => state.auth.user);

  useEffect(() => {
    acceptedInvite(inviteId);
  }, [inviteId, acceptedInvite]);

  if (isLoading || isUninitialized) {
    return <EmptyState icon={<Spin size='large' />} title='Validando convite' description={undefined} />;
  }

  if (error) {
    return getErrorMessage(error, user);
  }

  return <Navigate to='/cursos' />;
};

function getErrorMessage(error: any, user: IUser | null) {
  const makeLogout = () => {
    logout('');
  };

  switch (error?.status) {
    case 403:
      return (
        <EmptyState
          icon={<EmojiDizzy />}
          title='Esse convite não pertence ao usuário que você está logado.'
          description={
            <>
              <Typography>{user?.email}</Typography>
              <Typography>Por favor troque de usuário e tente novamente.</Typography>
              <Button size='large' className='buttonChangeUserInvite' type='primary' onClick={makeLogout}>
                Trocar de usuário
              </Button>
            </>
          }
        />
      );
    case 404:
      return <Navigate to='/resumo' />;
    default:
      return <Typography>Ops. Parece que houve algum erro ao tentar ativar o convite</Typography>;
  }
}

export default styled(Invite)`
  .buttonChangeUserInvite {
    margin-top: '10px';
  }
`;
